"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRobot = exports.isLocker = exports.is503 = exports.is501 = exports.is4XX = exports.is405 = exports.is403 = exports.is402g3 = exports.is402g2 = exports.is402 = exports.is401g2 = exports.is401g1 = exports.is401 = exports.is355 = exports.is354 = exports.is352 = exports.is351 = exports.is314 = exports.is313 = exports.is312 = exports.is311 = exports.is308 = exports.is302 = exports.is301 = void 0;
var BEC = 'backend-controller';
var is301 = exports.is301 = function is301(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 12 || !!(typeof type === 'string' && type.match(/cl301g\d/g));
};
var is302 = exports.is302 = function is302(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 5 || !!(typeof type === 'string' && type.match(/cl302g\d/g));
};
var is308 = exports.is308 = function is308(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 26 || !!(typeof type === 'string' && type.match(/cl308g\d/g));
};
var is311 = exports.is311 = function is311(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 21 || !!(typeof type === 'string' && type.match(/cl311g\d/g));
};
var is312 = exports.is312 = function is312(type) {
  return type === "".concat(BEC, "-cleveron-g2") ||
  // same as 311 for S2
  type === 21 || !!(typeof type === 'string' && type.match(/cl312g\d/g));
};
var is313 = exports.is313 = function is313(type) {
  return type === "".concat(BEC, "-cleveron-g2") ||
  // same as 301 for S2
  type === 12 || !!(typeof type === 'string' && type.match(/cl313g\d/g));
};
var is314 = exports.is314 = function is314(type) {
  return !!(typeof type === 'string' && type.match(/cl314g\d/g)) ||
  // combos are currently 301s
  is301(type);
};
var is351 = exports.is351 = function is351(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 19 || !!(typeof type === 'string' && type.match(/cl351g\d/g));
};
var is352 = exports.is352 = function is352(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 22 || !!(typeof type === 'string' && type.match(/cl352g\d/g));
};
var is354 = exports.is354 = function is354(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 24 || !!(typeof type === 'string' && type.match(/cl354g\d/g));
};
var is355 = exports.is355 = function is355(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 25 || !!(typeof type === 'string' && type.match(/cl355g\d/g));
};
var is401g1 = exports.is401g1 = function is401g1(type) {
  return type === "".concat(BEC, "-packrobot") || type === 11 || type === 'cl401g1';
};
var is401g2 = exports.is401g2 = function is401g2(type) {
  return type === "".concat(BEC, "-packrobot") || type === 18 || type === 'cl401g2';
};
var is401 = exports.is401 = function is401(type) {
  return is401g1(type) || is401g2(type);
};
var is402g2 = exports.is402g2 = function is402g2(type) {
  return type === "".concat(BEC, "-flex-gen2") || type === 15 || type === 'cl402g2';
};
var is402g3 = exports.is402g3 = function is402g3(type) {
  return type === "".concat(BEC, "-flex-gen2") || type === 15 || type === 'cl402g3';
};
var is402 = exports.is402 = function is402(type) {
  return is402g2(type) || is402g3(type);
};
var is403 = exports.is403 = function is403(type) {
  return type === "".concat(BEC, "-403") || type === 17 || type === 'cl403g1';
};
var is405 = exports.is405 = function is405(type) {
  return type === "".concat(BEC, "-403") || type === 20 || type === 'cl405g1';
};
var is501 = exports.is501 = function is501(type) {
  return type === "".concat(BEC, "-groceryflex") || type === 16 || type === 'cl501g1';
};
var is503 = exports.is503 = function is503(type) {
  return type === "".concat(BEC, "-cleveron-g2") || type === 23 || type === 'cl503g1';
};
var isLocker = exports.isLocker = function isLocker(type) {
  return is301(type) || is302(type) || is308(type) || is311(type) || is312(type) || is313(type) || is314(type) || is351(type) || is352(type) || is354(type) || is355(type) || is503(type) || !!(typeof type === 'string' && type.match(/cl3\d\dg\d/g));
}; // catch-all
var is4XX = exports.is4XX = function is4XX(type) {
  return is401(type) || is402(type) || is403(type) || is405(type) || !!(typeof type === 'string' && type.match(/cl4\d\dg\d/g));
}; // catch-all
var isRobot = exports.isRobot = function isRobot(type) {
  return is4XX(type) || is501(type);
};